import React from 'react'
import JobsList from '../components/JobsList'

function Home() {
  return (
    <div>
    <JobsList />
    </div>
  )
}

export default Home